import { render } from "./DataImporter.vue?vue&type=template&id=06d370a9"
import script from "./DataImporter.vue?vue&type=script&lang=js"
export * from "./DataImporter.vue?vue&type=script&lang=js"
script.render = render

export default script